<template>
  <div class="ticketWrapper" ref="ticketWrapper">
    <Scrollable>
      <div
        class="betslipTicket"
        :class="{clearBetslip: isClearBetslip}"
        :style="{ height: isMobile && mobileTicketHeight }">
          <div class="bet" v-for="(bet, index) in ticket" :key="index">
            <BetslipBet :bet="bet" :isLastBet="isLastBet(index)" />
          </div>
      </div>
    </Scrollable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Scrollable from '../../Scrollable';
import BetslipBet from './BetslipBet';
import { eventBus } from '../../../utility';

export default {
  name: 'BetslipTicket',
  data() {
    return {
      isClearBetslip: false,
    };
  },
  components: {
    BetslipBet,
    Scrollable,
  },
  computed: {
    ...mapGetters('gamesBetslip', ['isCombo', 'ticket', 'numberOfBets', 'mobileTicketHeight']),
    ...mapGetters(['translations', 'isMobile']),
    desktopHeight() {
      const footerSingleHeight = getComputedStyle(document.body).getPropertyValue('--footer-single-height');
      const footerComboHeight = getComputedStyle(document.body).getPropertyValue('--footer-combo-height');

      if (this.isCombo) {
        return `${footerSingleHeight - footerComboHeight}px`;
      }

      return '0px';
    },
  },
  methods: {
    isLastBet(index) {
      return this.numberOfBets === index + 1;
    },
  },
  updated() {
    this.$nextTick(() => {
      document.body.style.setProperty('--footer-difference', this.desktopHeight);
    });
  },
  mounted() {
    eventBus.$on('ClearBetslip', () => {
      this.isClearBetslip = true;

      setTimeout(() => {
        this.isClearBetslip = false;
      }, 300);
    });

    document.body.style.setProperty('--footer-difference', this.desktopHeight);
  },
  // Vue 2 vs Vue3 issue => beforeDestroy hook doesn't exist in vue3 it's changed to beforeUnmount
  beforeUnmount() {
    eventBus.$off('ClearBetslip');
  },
  beforeDestroy() {
    eventBus.$off('ClearBetslip');
  },
};
</script>

<style lang="scss" scoped>
.ticketWrapper {
  overflow: hidden;
  position: relative;

  div.betslipTicket {
    font-size: 14px;
    height: calc(352px + var(--footer-difference));
    overflow-x: hidden;
    scroll-snap-type: y mandatory;

    &.clearBetslip {
      position: relative;
      animation-name: clear;
      animation-duration: 0.35s;
      transition-timing-function: ease-out;
    }

    .bet {
      display: flex;
      flex-direction: column;
      margin-bottom: 1px;
      justify-content: center;
      min-height: 92px;
      border-radius: 2px;
      scroll-snap-align: start;
    }
  }
}

@keyframes clear {
  0% {
    position: relative;
    transform: translateX(0%);
  }
  100% {
    position: relative;
    transform: translateX(100%);
  }
}
</style>
